import { Link } from "react-router-dom";
import { popularManhwa } from "@/mocks/manhwa";

export default function PopularSection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-600">万千读者共同选择的热门韩漫</p>
          </div>
          <Link
            to="/category/romance"
            className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-6" data-product-shop>
          {popularManhwa.map((manhwa, idx) => (
            <Link
              key={manhwa.id}
              to={`/article/${manhwa.id}`}
              className="group cursor-pointer"
            >
              <div className="relative w-full aspect-[3/4] rounded-lg overflow-hidden mb-3 bg-background-200">
                <img
                  src={manhwa.cover}
                  alt={manhwa.title}
                  title={`${manhwa.title} - 免费韩漫在线阅读`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-2 left-2">
                  <span className={`text-[10px] font-medium px-2 py-0.5 rounded ${
                    idx < 3 ? "bg-accent-500 text-white" : "bg-background-950/60 text-white"
                  }`}>
                    {idx + 1}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                  <span className="text-[10px] text-white/80 bg-white/20 px-1.5 py-0.5 rounded">
                    {manhwa.status}
                  </span>
                </div>
              </div>
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1 mb-1">
                {manhwa.title}
              </h3>
              <p className="text-xs text-foreground-500">{manhwa.author}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}